const API = 'https://api-content.zagoo.vn/api';
const POSTS_PATH = '/post?';
const GAME_ID = 65640;

const getPostByType = (
  type: string,
  from: number,
  count: number
): any => {
  const urlParams = new URLSearchParams({
    gameId: GAME_ID.toString(),
    type,
    from: from.toString(),
    count: count.toString(),
    public: 'true',
  });

  return fetch(API + POSTS_PATH + urlParams.toString())
    .then((response) => response.json())
    .then((response) => response.data);
};

const getPostDetails = (postId: string) => {
  const urlParams = new URLSearchParams({
    gameId: GAME_ID.toString(),
    postId: postId.toString(),
    public: 'true',
  });

  return fetch(API + POSTS_PATH + urlParams.toString())
    .then((response) => response.json())
    .then((response) => response.data);
};

const PostServices = {
  getPostByType,
  getPostDetail: getPostDetails
};

export default PostServices;
